import styled from "styled-components";

export const PurchaseOrderListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const ColumnText = styled.div`
  color: ${(props) => props.color ?? "#474747"};
  font-family: "Lato";
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  text-decoration: ${(props) => props.decoration ?? "none"};
`;

export const ColumnTextSpan = styled.span`
  color: ${(props) => props.color ?? "#474747"};
  font-family: "Lato";
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  text-decoration: ${(props) => props.decoration ?? "none"};
  cursor: pointer;
`;

export const ColumnTextWrapper = styled.span`
  white-space: normal;
  word-break: break-word;
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 4px;

  div {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 4px;
  }
`;